module.exports = __webpack_public_path__ + "img/empty_todo.1f922c20.png";